export const BE_DATE_FORMAT = "YYYY-MM-DD";

export const BE_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm";

export const BE_TIME_FORMAT = "HH:mm";
